export default __webpack_public_path__ + "static/media/rank-drop-exp.b6963d16.png";